import React from 'react';
import styled from 'styled-components';

import { ErrorIllustration } from './ErrorIllustration';

const ErrorContainer = styled.div`
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--gray-02);
`;

type Props = {
  errorMessage: string;
};

export const FullPageError: React.FC<Props> = ({ errorMessage }) => {
  return (
    <ErrorContainer>
      <ErrorIllustration errorMessage={errorMessage} />
    </ErrorContainer>
  );
};
